const HOST_URL_IMAGE = "https://survey.besins-healthcare.vn/images/";

export default HOST_URL_IMAGE;
